var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.992.666c-2.96 0-5 2.04-5 5v1.666c0 .834-.135 1.284-.599 1.667l-.338.287C1 10.157.483 10.974.492 12.332c.007.899.744 1.676 1.667 1.667h3.492s-.159.51-.159.833a2.5 2.5 0 1 0 5 0c0-.324-.152-.833-.152-.833h3.486a1.677 1.677 0 0 0 1.666-1.667c.002-1.348-.521-2.179-1.562-3.046-.069-.058-.31-.242-.364-.287-.455-.378-.574-.833-.574-1.667V5.666c0-2.96-2.04-5-5-5m0 13.333a.834.834 0 1 1 0 1.667.834.834 0 0 1 0-1.667"
  })));
};
export default SvgBell;